export default __webpack_public_path__ + "static/media/background-share.d51c555b.jpg";